import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "categories-favorites-and-trash",
  courseId: "writing-and-editing",
  order: 5,
  title: "Organize cases",
  subtitle: "Categories, favorites, Trash",
  summary:
    "Sort your cases into personal categories in the sidebar, star the ones you keep returning to, and delete the rest to a Trash that empties on your department's schedule.",
  learn: [
    "Create categories and file cases into them",
    "Star a case into Favorites",
    "Delete, restore, and understand trash retention",
  ],
  minutes: 3,
  releasedAt: "2026-05-26T00:00:00.000Z",
  sceneId: "categories-favorites-and-trash",
  tourId: "categories-favorites-and-trash",
  body: [
    {
      type: "paragraph",
      text: "When your case list gets long, categories let you group it the way you think about your work. They are personal: nobody else sees your list, and one case can sit in several categories. Favorites is a special category you fill with a star.",
    },
    { type: "heading", text: "Categories and Favorites" },
    {
      type: "steps",
      items: [
        "In the sidebar, click the + next to **Categories** (its tooltip reads \"New category\").",
        "In the \"New Category\" dialog, type a name (for example \"Traffic Stops\") and click **Create**.",
        "Drag a case from the list onto the category. Or open the case, click the tag icon in the toolbar (\"Add to category\"), and tick the categories.",
        "Hover a category and click the three dots (\"⋯\") to choose **Rename** or **Delete**.",
        "Click the star in the editor toolbar (\"Add to Favorites\") to pin a case under **Favorites**.",
      ],
    },
    {
      type: "paragraph",
      text: "Deleting a category does not delete the cases in it.",
    },
    { type: "heading", text: "Trash" },
    {
      type: "steps",
      items: [
        "Drag a case onto **Trash** in the sidebar. Or select a case in the list and click the trash icon above the list.",
        "Click **Trash** to see what you have deleted.",
        "Open a case there and click **Restore**. It appears where **Export** normally is.",
      ],
    },
    {
      type: "callout",
      tone: "note",
      title: "Retention",
      text: "The banner in Trash reads \"Cases older than N days are automatically deleted\". N comes from your department's Data Retention policy, so check the banner before you count on getting something back.",
    },
    {
      type: "paragraph",
      text: "Trashed cases do not show in categories or Favorites, and search skips them. Restoring puts a case back exactly as it was, categories included.",
    },
  ],
  related: ["editor-essentials", "the-agency-dashboard"],
};

export default lesson;
